import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import { useNavigate } from "react-router-dom"

import DarkWrapper from "../../../common/components/DarkWrapper"

export default function PageNotFound() {
  const navigate = useNavigate()

  return (
    <DarkWrapper>
      <GrayCenteredText variant="h1" sx={{ fontSize: "10em", fontWeight: 500 }}>
        404
      </GrayCenteredText>
      <GrayCenteredText
        variant="h4"
        sx={{
          mt: (theme) => theme.spacing(1),
          fontSize: "2em",
          fontWeight: 700,
        }}
      >
        Sorry, This Page Was Not Found
      </GrayCenteredText>
      <GrayCenteredText
        variant="body1"
        sx={{ mt: (theme) => theme.spacing(1) }}
      >
        The link you followed is probably broken or the page has been removed.
      </GrayCenteredText>
      <Button
        variant="contained"
        onClick={() => navigate("/", { replace: true })}
        sx={{ mt: (theme) => theme.spacing(2) }}
      >
        Go to homepage
      </Button>
    </DarkWrapper>
  )
}

const GrayCenteredText = styled(Typography)(({ theme }) => ({
  color: "#767676",
  textAlign: "center",
}))
